export const DISTRIBUTION_STRATEGY = [
  { id: 'EXECUTION_ONLY', displayValue: 'Execution Only' },
  { id: 'ADVISED', displayValue: 'Advised' },
  { id: 'NON_ADVISED', displayValue: 'Non advised' },
];

export const DISTRIBUTION_STRATEGY_MAP = {
  EXECUTION_ONLY: 'Execution Only',
  ADVISED: 'Advised',
  NON_ADVISED: 'Non advised',
};
